import { apiService } from '../../utils/api';

export interface OperationData {
  id: number;
  device_id: string;
  cmd: string;
  account: string;
  source: string;
  operation_type: number;
  status: number;
  data: any;
  additional_info: string;
  timestamp: number;
  created_at: string;
  is_response: number;
}

export interface OperationDataListData {
  operations: OperationData[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
    hasNext: boolean;
    hasPrev: boolean;
  }
}

export interface OperationDataListParams {
  page: number;
  pageSize: number;
  deviceId?: string;
  account?: string;
  operationType?: number;
  status?: number;
  source?: string;
  cmd?: string;
  isResponse?: number;
  startTime?: string;
  endTime?: string;
}

// Function to fetch operation data with pagination and filters
export const fetchOperationData = async (params: OperationDataListParams): Promise<OperationDataListData> => {
  try {
    const queryParams = new URLSearchParams();
    queryParams.append('page', params.page.toString());
    queryParams.append('pageSize', params.pageSize.toString());
    
    if (params.deviceId) {
      queryParams.append('deviceId', params.deviceId);
    }
    
    if (params.account) {
      queryParams.append('account', params.account);
    }
    
    if (params.operationType !== undefined) {
      queryParams.append('operationType', params.operationType.toString());
    }
    
    if (params.status !== undefined) {
      queryParams.append('status', params.status.toString());
    }
    
    if (params.source) {
      queryParams.append('source', params.source);
    }
    
    if (params.cmd) {
      queryParams.append('cmd', params.cmd);
    }
    
    if (params.isResponse !== undefined) {
      queryParams.append('isResponse', params.isResponse.toString());
    }
    
    if (params.startTime) {
      queryParams.append('startTime', params.startTime);
    }
    
    if (params.endTime) {
      queryParams.append('endTime', params.endTime);
    }
    
    // Using apiService - it directly returns the data part
    return await apiService.get<OperationDataListData>(`/api/v1/admin/operation-data?${queryParams.toString()}`);
  } catch (error) {
    console.error('Failed to fetch operation data:', error);
    throw error;
  }
};

// Function to count operation data with filters
export const countOperationData = async (params: Partial<OperationDataListParams>): Promise<{ total: number }> => {
  try {
    const queryParams = new URLSearchParams();
    
    if (params.deviceId) {
      queryParams.append('deviceId', params.deviceId);
    }
    
    if (params.account) {
      queryParams.append('account', params.account);
    }
    
    if (params.operationType !== undefined) {
      queryParams.append('operationType', params.operationType.toString());
    }
    
    if (params.status !== undefined) {
      queryParams.append('status', params.status.toString());
    }
    
    if (params.source) {
      queryParams.append('source', params.source);
    }
    
    if (params.cmd) {
      queryParams.append('cmd', params.cmd);
    }
    
    if (params.isResponse !== undefined) {
      queryParams.append('isResponse', params.isResponse.toString());
    }
    
    if (params.startTime) {
      queryParams.append('startTime', params.startTime);
    }
    
    if (params.endTime) {
      queryParams.append('endTime', params.endTime);
    }
    
    return await apiService.get<{ total: number }>(`/api/v1/admin/operation-data/count?${queryParams.toString()}`);
  } catch (error) {
    console.error('Failed to count operation data:', error);
    throw error;
  }
}; 